// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xxxxlargeOnWide-badge-8fe3efca"};